import rejectNonOkResponse from '../../rejectNonOkResponse.js';
import { comparePreviewURL } from '../../../configuration/index.js';

const defaultImage = '/svg/product/noscan_200x200.svg';

/** @typedef {import('./typedefs.js').CompareItem} CompareItem */

/**
 * Get compare items data from API
 *
 * @param {Object} param0
 * @param {CompareItem[]} param0.items Items to fetch data for
 * @returns {Promise<CompareItem[]>}
 */
export default async function getCompareItemsData({ items }) {
  const url = Object.assign(new URL(comparePreviewURL, document.baseURI), {
    search: new URLSearchParams(items.map(({ prid, catalog }) => ['products', `${catalog}-${prid}`]))
  });

  const data = await (await rejectNonOkResponse(fetch(url))).json();

  // Fill missing/ghost items (eg. inactive) with fake infos
  return items.map(
    ({ prid, catalog, type }) =>
      data.find((item) => prid === String(item.prid) && catalog === String(item.catalog)) ?? {
        prid,
        catalog,
        type,
        name: '????',
        averageRating: 0,
        imageSrc: defaultImage,
        inactive: true
      }
  );
}
